// THE PHONE MENU — the markup, for both bars.
//
// Under 780 px the bar at the top of the annex pages (components/site-nav.tsx) and the relay capsule that takes
// over on scroll (components/site-fixed-nav.tsx) show the same thing: the mark, and a Menu button that opens a
// white card. This file is that button, written once. Its recipe is components/nav-menu.css, also written once.
//
// It was NOT written once on 22/09 — the capsule got a copy of the top bar's <details>, and the copy had already
// lost the panel's named values. That is the defect this repo has paid twice (site-nav.css was born as a copy of
// home-v2/nav.css, the two drifted, and Jérémy reported the same defect twice on 19/09). Caught in review.
//
// `block` is the bar's class family, kept because each bar owns its names (site-nav.css is only allowed to
// declare .v2-sitenav* — tests/site-chrome.test.tsx) and because the rendered HTML of the top bar, which is
// pinned, does not change by a character. One component, one sheet, two families of names, no second recipe.
//
// No "use client": this is markup and nothing else, so site-nav.tsx stays a server component.
// No aria-expanded on purpose: the browser already exposes the state from the <details>, and writing it by hand
// freezes it on a value that stops being true.

import "./nav-menu.css";

export default function NavMenu({ block }: { block: "v2-sitenav" | "v2-fixednav" }) {
  return (
    <details className={`${block}__menu`}>
      <summary className={`${block}__summary`}>
        <span className={`${block}__burger`} aria-hidden="true">
          <span className={`${block}__bar`} />
          <span className={`${block}__bar`} />
          <span className={`${block}__bar`} />
        </span>
        {/* The three strokes name nothing: the accessible name is this word, read but not drawn. */}
        <span className={`${block}__menulabel`}>Menu</span>
      </summary>
    </details>
  );
}
